import { APP_ENVIRONMENT } from "./envs";

export const isLocal = true;
export const LOCAL_URL = process.env.REACT_APP_API_URL || "https://develop.api.frdmbank.io";
// export const LOCAL_URL = "http://localhost:4001";
export const TEST_URL = "https://test-backend.midl.finance";

export const ALACRITY_URL = "https://rpc.mainnet.alaio.net";
// export const ALACRITY_URL = "https://alaio.alacritys.net";
// export const ALACRITY_URL = "https://hyperion.alacritys.net"

// export const PROD_ENVIRONMENT = APP_ENVIRONMENT !== "PRODUCTION";
export const PROD_ENVIRONMENT = false;
export const CONTRACT_NAME = PROD_ENVIRONMENT ? "midl" : "midltest5";
export const TOKEN_CONTRACT = PROD_ENVIRONMENT ? "opn" : "opn";
export const ESCROW_CONTRACT_NAME = "midl.escrow";
export const TIMESTAMP_DEFAULT_FORMAT = "D/M/YY, h:mm A";
export const CURRENCY_LOCALE = {
    format: "en-US",
    fixedPointFormat: {
        style: 'decimal',  // Other options: 'currency', 'percent', etc.
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }
};

/**
 * Custodian collateral split: share of collateral that is business limit, in
 * basis points (9000 = 90% business limit, 10% locked).
 *
 * ONE constant per repo, kept equal by hand (like the fee constants):
 *   - contracts: BUSINESS_LIMIT_BPS in
 *     midl-contracts-solidity/contracts/router/FrdmRouterCommonImpl.sol
 *   - backend:   BUSINESS_LIMIT_BPS in midl-server/src/config/collateral.ts
 *   - client:    here
 * Change all three together. See midl-server/docs/BUSINESS-LIMIT-90-PLAN.md.
 */
export const BUSINESS_LIMIT_BPS = 9000;
